import { Box, Stack } from "@mui/material";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";
import { base64ToFile } from "src/utils/file";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const CustomLogo = () => {
	const { theme } = useContext(Context);
	const isMobile = useResponsive("down", "sm");

	return (
		<Stack
			id='custom-logo'
			sx={{
				width: "100%",
				height: isMobile ? 45 : 60,
				alignItems: "flex-start",
				justifyContent: "flex-start",
				position: "relative",
				mb: 2
			}}
		>
			<Box
				component='img'
				sx={{
					height: isMobile ? 45 : 60,
					position: "absolute"
				}}
				src={URL.createObjectURL(base64ToFile(theme?.logo!, "logo"))}
			/>
		</Stack>
	);
};

export default CustomLogo;
